import { FieldArray } from 'formik';
import AddButton from "./UI/AddButton";
import Accordion from './UI/Accordion';
import FieldGroupContainer from "./UI/FieldGroupContainer";
import MembersInput from "./MembersInput";
import { cloneDeep } from "lodash";

const newMember = {
  title: "Department Role 1",
  name: "Department Member Name",
  phone: "",
  email: ""
}

const newDepartment = {
  name: "Department 1",
  members: [cloneDeep(newMember)]
}


const DepartmentsInput = ({departments, setField}) => {
  return(
    <FieldArray name="departments">
      {({ insert, remove, push }) => (
        <div>
          {departments.length > 0 &&
            departments.map((departments, index) => (
              <Accordion
                key={index}
                title={departments.name}
                fieldSetter={(e) => setField(`departments[${index}].name`, e.target.value)}
                deleteMethod={() => remove(index)}
              >
                <FieldGroupContainer>
                  <MembersInput
                    members={departments.members}
                    setField={setField}
                    departmentIndex={index}
                  />
                </FieldGroupContainer>
              </Accordion>
            ))}
          <AddButton
            type="button"
            onClick={() => push({...newDepartment, name: `Department ${departments.length + 1}`})}
          >
            Add Department
          </AddButton>
        </div>
      )}
    </FieldArray>
  )
}

export default DepartmentsInput;
